const section = {
  about: 'About me',
  projects: 'Projects',
  blogs: 'Blogs',
  skills: 'Skills',
  contact: 'Get in touch 🤙',
  projectDetails: 'Details',
  seeMoreGithub: 'See More in GitHub',
  moreArticle: 'More article',
  downloadResume: 'Download Resume',
};

export default section;
